import PropTypes from 'prop-types';

import { IconGeneric } from '@spotahome/ui-library';

import './GalleryArrow.scss';

const GalleryNavigator = ({ navRole, onClick }) => (
  <div className={`gallery-arrow gallery-arrow--${navRole}`} onClick={onClick}>
    <IconGeneric
      name={navRole === 'prev' ? 'angle-left' : 'angle-right'}
      className="circle-arrow"
    />
  </div>
);

GalleryNavigator.propTypes = {
  navRole: PropTypes.oneOf(['next', 'prev']).isRequired,
  onClick: PropTypes.func.isRequired
};

export default GalleryNavigator;
